import { Trans } from 'react-i18next'
import { Checkbox, Form } from 'antd'

export const SmsMarketingConsent = () => {
  return (
    <div
      className='flex items-start gap-2'
      data-testid='sms-marketing-consent'
    >
      <Form.Item
        name='sms_notifications'
        valuePropName='checked'
        noStyle
      >
        <Checkbox data-testid='sms-marketing-checkbox' />
      </Form.Item>
      <Trans
        parent='span'
        i18nKey='messaging_consent_text'
        data-testid='sms-marketing-text'
        components={{
          portalLink: (
            <a
              href='https://my.taptelehealth.com'
              target='_blank'
              rel='noopener noreferrer'
              aria-label='my.taptelehealth.com'
              data-testid='portal-link'
            />
          ),
          termsLink: (
            <a
              href='https://www.taptelehealth.com/terms-of-service'
              target='_blank'
              rel='noopener noreferrer'
              aria-label='Terms of Service'
              data-testid='terms-link'
            />
          ),
          privacyLink: (
            <a
              href='https://www.taptelehealth.com/privacy-policy'
              target='_blank'
              rel='noopener noreferrer'
              aria-label='Privacy Policy'
              data-testid='privacy-link'
            />
          ),
        }}
      />
    </div>
  )
}
